import Card from "../../../components/core/basic/Card";
import CustomHref from "../../../components/core/blocks/CustomHref";
import PaymentDetailsForm from "../../../modules/billing/components/PaymentDetailsForm";
import { StripeElements } from "../../../modules/billing/components/StripeElements";
import { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createFileRoute } from "@tanstack/react-router";
import { withRouter } from "../../../hocs/withRouter";
import { refreshAmzOnboardStatus, updateAmzOnboardingStatus } from "../../../redux/reducers/amzOnboardReducer";
import { setErrors } from "../../../redux/reducers/errorReducers";
import { SubscriptionCard } from "../../../modules/billing/components/SubscriptionCard";
import { formatCurrency } from "../../../utils/formatNumber";
import { css } from "../../../../styled-system/css";
import { Divider, Grid, HStack, VStack } from "../../../../styled-system/jsx";

class PaymentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userLayout: false,
    };
  }

  componentDidMount() {
    refreshAmzOnboardStatus(this.props.updateAmzOnboardingStatus, this.props.setErrors);
  }

  componentDidUpdate() {
    if (window.location.href.includes("user") && !this.state.userLayout) {
      // oxlint-disable-next-line react/no-did-update-set-state
      this.setState({ userLayout: true });
    }
  }

  setCountry = (country) => {
    this.setState({ cardCountry: country });
  };

  render() {
    const { t } = this.props;
    const { planDetails, monthlyChecked } = this.props.location?.state ?? {};

    const getPriceDisplay = (isAnnual) => {
      const amount = isAnnual ? planDetails?.annual?.pay : planDetails?.monthly?.pay;
      if (!amount)
        return planDetails?.displayName === "Custom" ? t(($) => $.onboarding["TBD"]) : t(($) => $.onboarding["Free"]);
      if (amount === 0) return t(($) => $.onboarding["Free"]);
      return `${formatCurrency(amount, { marketPlace: "USA" })} USD`;
    };

    const subtotal = getPriceDisplay(!monthlyChecked);

    const getTaxes = () => {
      if (this.state.cardCountry !== "CA") return null;
      const amount = monthlyChecked ? planDetails?.monthly?.pay : planDetails?.annual?.pay;
      if (!amount) return null;
      return `${formatCurrency(amount * 0.13, { marketPlace: "USA" })} USD`;
    };

    const getTotal = () => {
      const multiplier = this.state.cardCountry === "CA" ? 1.13 : 1;
      const amount = monthlyChecked ? planDetails?.monthly?.pay : planDetails?.annual?.pay;
      if (!amount && amount !== 0) return t(($) => $.onboarding["TBD"]);
      if (amount === 0) return t(($) => $.onboarding["Free"]);
      return `${formatCurrency(amount * multiplier, { marketPlace: "USA" })} USD`;
    };

    return (
      <Grid columns={{ base: 1, lg: "1fr 420px" }} translate="no" className={css({ minHeight: "100vh" })}>
        <div className={css({ backgroundColor: "white", overflowX: "hidden" })}>
          <StripeElements>
            <PaymentDetailsForm
              discoveryType={this.props.location?.state?.discoveryType}
              promoCode={this.props.location?.state?.promoCode}
              setCountry={this.setCountry}
            />
          </StripeElements>
          <div className={css({ marginTop: "xlarge", marginBottom: "large", marginLeft: "2rem" })}>
            <span
              className={css({ fontSize: "14px" })}
              onClick={() => {
                if (this.state.userLayout) {
                  this.props.location?.state?.discoveryType === "search-analytics" ?
                    this.props.navigate({ to: "/user/searchanalytics" })
                  : this.props.location?.state?.discoveryType === "pricing" ?
                    this.props.navigate({ to: "/user/pricing/dashboard" })
                  : this.props.navigate({ to: "/user/dashboard" });
                } else {
                  this.props.navigate({ to: "/user/plans" });
                }
              }}
            >
              <CustomHref
                text={
                  this.state.userLayout ? t(($) => $.onboarding["Change Subscription"]) : t(($) => $.onboarding["Back"])
                }
                color={"#c8c8c8"}
              />
            </span>
          </div>
        </div>

        {/* Right: Subscription card + price summary (hidden on mobile) */}
        {this.props.location?.state?.discoveryType && (
          <VStack
            gap="large"
            alignItems="stretch"
            css={{
              display: { base: "none", lg: "flex" },
              position: "sticky",
              top: 0,
              alignSelf: "start",
              padding: "xlarge",
              paddingTop: "30vh",
            }}
            translate="yes"
          >
            <SubscriptionCard
              planId={planDetails?.displayName}
              planName={planDetails?.displayName}
              core={true}
              monthlySubscriptionPrice={
                planDetails?.monthly?.pay ? `$${planDetails?.monthly.pay}`
                : planDetails?.displayName === "Custom" ?
                  t(($) => $.onboarding["TBD"])
                : t(($) => $.onboarding["Free"])
              }
              annualSubscriptionPrice={
                planDetails?.monthly?.pay ?
                  `${formatCurrency(planDetails?.monthly.pay * 0.9, {
                    marketPlace: "USA",
                    decimalPlaces: 0,
                  })}`
                : planDetails?.displayName === "Custom" ?
                  t(($) => $.onboarding["TBD"])
                : t(($) => $.onboarding["Free"])
              }
              monthlyChecked={monthlyChecked}
              subscriptionFeatures={
                <>
                  {typeof planDetails?.features === "object" ?
                    planDetails?.features.map((feature) => (
                      <Fragment key={feature}>
                        <span>{feature}</span>
                        <br />
                      </Fragment>
                    ))
                  : planDetails?.features}
                </>
              }
              selectedSubscription={planDetails?.displayName}
              annualSales={
                planDetails?.annualSales && planDetails?.annualSales !== "n/a" ? planDetails?.annualSales : null
              }
            />

            <Card variant="flat">
              <VStack gap="small" alignItems="stretch">
                <HStack justify="space-between">
                  <span className={css({ fontWeight: 500, color: "text.secondary" })}>
                    {t(($) => $.onboarding["Subtotal"])}
                  </span>
                  <span className={css({ fontWeight: 500, color: "text.secondary" })}>{subtotal}</span>
                </HStack>

                {(() => {
                  const taxes = getTaxes();
                  return (
                    taxes && (
                      <HStack justify="space-between">
                        <span className={css({ fontWeight: 500, color: "text.secondary" })}>
                          {t(($) => $.onboarding["Taxes"])}
                        </span>
                        <span className={css({ fontWeight: 500, color: "text.secondary" })}>{taxes}</span>
                      </HStack>
                    )
                  );
                })()}

                <Divider />

                <HStack justify="space-between">
                  <span className={css({ fontWeight: 500, color: "text.secondary" })}>
                    {t(($) => $.onboarding["Total"])}
                  </span>
                  <span className={css({ fontWeight: 500, color: "text.secondary" })}>{getTotal()}</span>
                </HStack>
              </VStack>
            </Card>
          </VStack>
        )}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  amz_onboard: state.amz_onboard,
  user: state.user,
});

const mapDispatchToProps = {
  updateAmzOnboardingStatus,
  setErrors,
};

export const Route = createFileRoute("/_authenticated/user/payment")({
  component: connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation(["onboarding"])(PaymentDetails))),
  staticData: { application: "Admin" },
});
